import React from 'react';
import { gettext } from '@eb/i18n';

import './CoronavirusBanner.scss';

// eslint-disable-next-line no-unused-vars
const CORONAVIRUS_HEADER = gettext("We're here to help");

const CORONAVIRUS_BODY = gettext(
    'See our latest COVID-19 resources to stay safe and manage your events - for <a href="/l/coronavirus-resources-event-attendees/">attendees</a> and <a href="/l/coronavirus-resources-event-organizers/">creators</a>.',
);

const CoronavirusBanner = () => {
    return (
        <div className="feed-coronavirus-banner">
            <span
                className="feed-coronavirus-banner__header-text eds-text-bl"
                //eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: CORONAVIRUS_HEADER,
                }}
            />
            <span
                className="feed-coronavirus-banner__body-text"
                //eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: CORONAVIRUS_BODY,
                }}
            />
        </div>
    );
};

export default CoronavirusBanner;
